import { COUNTRY_CODES } from 'constants/country-codes';

import * as styled from '../styles';

type Props = {
  countryCode: string;
  localNumber: string;
  isLoading: boolean;
  error: string | null;
  onCountryCodeChange: (value: string) => void;
  onLocalNumberChange: (value: string) => void;
  onRequestOtp: () => void;
};

export const PhoneStep = ({
  countryCode,
  localNumber,
  isLoading,
  error,
  onCountryCodeChange,
  onLocalNumberChange,
  onRequestOtp,
}: Props) => {
  const selectedCountry =
    COUNTRY_CODES.find((country) => country.code === countryCode) ?? COUNTRY_CODES[0];

  return (
    <>
      <styled.Heading>Subscribe</styled.Heading>
      <styled.Subheading>
        Enter your phone number to subscribe or renew your Kudable provider
        account.
      </styled.Subheading>

      <styled.Card>
        <styled.Label>Phone number</styled.Label>
        <styled.PhoneRow>
          <styled.CountrySelect
            value={countryCode}
            onChange={(event) => onCountryCodeChange(event.target.value)}
            disabled={isLoading}
          >
            {COUNTRY_CODES.map((country) => (
              <option key={country.code} value={country.code}>
                {country.flag} {country.code}
              </option>
            ))}
          </styled.CountrySelect>
          <styled.PhoneDivider />
          <styled.PhoneInput
            type="tel"
            placeholder="555 123 4567"
            value={localNumber}
            onChange={(event) => onLocalNumberChange(event.target.value)}
            disabled={isLoading}
            onKeyDown={(event) => event.key === 'Enter' && onRequestOtp()}
          />
        </styled.PhoneRow>
        <styled.PhoneHint>
          {selectedCountry.flag} {selectedCountry.name} · {countryCode}
        </styled.PhoneHint>

        {error && <styled.ErrorText>{error}</styled.ErrorText>}

        <styled.Button
          disabled={isLoading || !localNumber.trim()}
          onClick={onRequestOtp}
        >
          {isLoading ? 'Sending code...' : 'Send Code'}
        </styled.Button>
      </styled.Card>
    </>
  );
};
